import React, { useState } from 'react';
import Slider from 'rc-slider';
import { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import { Link } from "react-router-dom"
import { ReactSession } from 'react-client-session';
import ProjectSlection from "../../components/projects/ProjectSelection"
import { display, style } from '@mui/system';
import { useEffect } from 'react';
import FilterPannerComponent from "../../components/projects/FilterPannerComponents"
import axios from "axios";
import blockZoneMapData from '../../block-zone.json';
import { useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { INVENTORY_2D_API, INVENTORY_2D_API_ACCESS_KEY } from "../../helper/constants";
import ReactKrishViewer from "../../helper/ReactKrishViewer";

const Projects = () => {
    let navigate = useNavigate();
    const [projectsLoading, setProjectsLoading] = useState(false);
    const [bedroomArray, setBedroomArray] = useState([])
    const [allData, setAllData] = useState([])
    var [filteredArray, setFilteredArray] = useState([])
    const [phaseBuilds, setPhaseBuilds] = useState([])
    const [blockNames, setBlockNames] = useState({})
    const [buildUpArea, setBuildUpArea] = useState([100, 130, 160, 180, 211])
    var [allBedRooms, setAllBedRooms] = useState([])
    const [selectedTag, setSelectedTag] = useState({})
    var [currentPhase, setCurrentPhase] = useState(null)
    var [currentZone, setCurrentZone] = useState(null)
    var [selectNBVal, setSelectNBVal] = useState(null)
    var [startPrice, setSstartPrice] = useState(0);
    var [endPrice, setEndPrice] = useState(0);
    var [filterStore, setFilterStore] = useState({});
    const filterPannerComponentRef = useRef(null);
    const ReactKrishViewerRef = useRef(null);
    var [updateMap, setUpdateMap] = useState({});
    var [updateMap1, setUpdateMap1] = useState(1);
    var [updateMap2, setUpdateMap2] = useState(1);
    var [imageHidden, setImageHidden] = useState(false);
    var [appam, setAppam] = useState(false);
    const [filterPannel, setFilterPannel] = useState(false)
    const [updatedNoOfUnits, setUpdatedNoOfUnits] = useState(0);
    const buildUpAreaString = () => {
        const out = []
        buildUpArea.map((row, index) => {
            if (index < buildUpArea.length - 1) {
                if (index > 0) {
                    out.push((row + 1) + "-" + buildUpArea[index + 1])
                } else {
                    out.push(row + "-" + buildUpArea[index + 1])

                }
            }
        })
        return out
    }
    const applyFilter = (filter) => {

        updateSvgForBlockSelection(filter)

    }

    const svgLoad = () => {
        ReactSession.setStoreType("localStorage");
        ReactSession.set("filter", {})
    }
    async function loadData() {
        // try {
        if (proj === undefined) {
            axios.defaults.headers.get['x-api-key'] = INVENTORY_2D_API_ACCESS_KEY
            const res = await axios.get(INVENTORY_2D_API);
            if (res.data) {
                var proj = res.data;
                ReactSession.set("data", proj)
                handleJsonData(proj);
            }
        } else {
            handleJsonData(proj);
        }
        // } catch (error) {
        // }
    }

    function findZone(phase, block) {
        var data = ""
        return block;
        Object.keys(blockZoneMapData).forEach(function (key) {
            const keyEle = key.split(",")
            if (keyEle[0].trim() === phase) {
                const start = Number(keyEle[1])
                const end = Number(keyEle[2])
                const current = Number(block.trim())
                if ((current >= start) && (current <= end)) {
                    data = blockZoneMapData[key]
                    return
                }
            }
        });
        return data
    }
    const handleJsonData = (proj) => {
        startPrice = undefined
        endPrice = undefined
        //deSelectAll();
        //proj.data.forEach(unit => {
        proj.forEach(unit => {
            // TMI_1_1467_69_1
            var phase = "";
            setImageHidden(true)
            var block = String(unit.cubedotsId.split("_")[2]);
            var unitNo = String(unit.cubedotsId.split("_")[4]);
            var zone = findZone(phase, unit.block)
            if (unit.status === "available") {
                const unitTypeArr = unit.unitType //.split("+")
                const buildArea = Number((unit.builtUpArea))
                var noOfBeds = unitTypeArr[0]
                // remove 2-1 (A) to 2+2
                //              noOfBeds = noOfBeds.split(' ')[0]
                var typeOfBeds = unitTypeArr
                if (blockNames[zone] === undefined) {
                    blockNames[zone] = {}
                }
                if (blockNames[zone][block] === undefined) {
                    blockNames[zone][block] = {}
                }
                if (blockNames[zone][block][unitNo] === undefined) {
                    blockNames[zone][block][unitNo] = []
                }
                var current = blockNames[zone][block][unitNo]

                // Bedroom Type
                current.push(noOfBeds)
                // Bedroom Type sub
                current.push(typeOfBeds)

                var select = -1
                Array.from(buildUpArea).forEach(p => {
                    if (buildArea >= p) {
                        select++
                    }
                })
                current.push(buildUpArea[select])
                current.push(unit.priceInUsd)

                blockNames[zone][block][unitNo] = current

                if (startPrice === undefined) {
                    startPrice = endPrice = unit.priceInUsd
                } else if (startPrice > unit.priceInUsd) {
                    startPrice = unit.priceInUsd
                }
                if (endPrice / 100 < unit.priceInUsd / 100) {
                    endPrice = unit.priceInUsd
                }
            }
        });
        filterPannerComponentRef.current.setPriceRange(startPrice, endPrice)
        updateSvgForBlockSelection()
    }

    const updateSvgForBlockSelection = (filteredValue) => {
        ReactKrishViewerRef.current.resetItems()
        var filterBlock = {}
        var noOfUnits = 0
        if (filteredValue === undefined) {
            filteredValue = {}
        }
        var typeOfBedRooms = {}
        var areaOfBedRooms = {}
        var typeOfBedRoomsSub = {}
        var price = {}
        Object.keys(blockNames).map((zone, index1) => {
            var zoneSelect = false
            Object.keys(blockNames[zone]).map((block, index2) => {
                var blockSelect = false
                Object.keys(blockNames[zone][block]).map((unit, index3) => {
                    var select = 0
                    Object.keys(filteredValue).map((type, data) => {
                        var idx = 0
                        if (type == "NB") {
                            idx = 0
                            var w = 0
                            Object.keys(filteredValue[type]).map((type1, dd) => {
                                if (blockNames[zone][block][unit][idx] === filteredValue[type][type1]) {
                                    w = 1
                                }
                            })
                            select += w
                        } else if (type == "TB") {
                            idx = 1
                            var w = 0
                            Object.keys(filteredValue[type]).map((type1, dd) => {
                                if (blockNames[zone][block][unit][idx] === filteredValue[type][type1]) {
                                    w = 1
                                }
                            })
                            select += w
                        } else if (type == "AB") {
                            idx = 2
                            var w = 0
                            Object.keys(filteredValue[type]).map((type1, dd) => {
                                const min = Number(filteredValue[type][type1].split('-')[0])
                                const max = Number(filteredValue[type][type1].split('-')[1])
                                if (blockNames[zone][block][unit][idx] >= min &&
                                    blockNames[zone][block][unit][idx] <= max) {
                                    w = 1
                                }
                            })
                            select += w
                        } else if (type == "R") {
                            idx = 3
                            const min = Number(filteredValue[type].split('-')[0])
                            const max = Number(filteredValue[type].split('-')[1])
                            if (blockNames[zone][block][unit][idx] >= min &&
                                blockNames[zone][block][unit][idx] <= max) {
                                select++
                            }
                        }
                    })
                    if (checkIsFilter(filteredValue, select)) {
                        zoneSelect = true
                        noOfUnits++
                        typeOfBedRooms[blockNames[zone][block][unit][0]] = 1
                        typeOfBedRoomsSub[blockNames[zone][block][unit][1]] = 1
                        areaOfBedRooms[blockNames[zone][block][unit][2]] = 1
                        price[blockNames[zone][block][unit][3]] = 1
                    }
                })
            })
            if (zoneSelect) {
                selectItem(zone)
                allBedRooms.push(zone)
            }
        })

        if (filterPannerComponentRef.current) {
            filterPannerComponentRef.current.setAvailableUnits(noOfUnits)
            // filterPannerComponentRef.current.setPriceRange(startPrice, endPrice);
            if (Object.keys(filteredValue).length == 0) {
                firstTimeSet(typeOfBedRooms, typeOfBedRoomsSub)
            }
            setFilterStore(filteredValue)
        }
        if (ReactKrishViewerRef.current) {
            ReactKrishViewerRef.current.resetCurrentSelection()
        }
    }
    useEffect(() => {
    }, [updatedNoOfUnits]);
    const checkIsFilter = (filteredValue, select) => {
        var idx = 0
        Object.keys(filteredValue).map((type1, d1) => {
            if (type1 == "R") {
                if (filteredValue[type1].length > 0) {
                    idx++
                }
            } else {
                var w = 0
                Object.keys(filteredValue[type1]).map((type2, d2) => {
                    if (type2.length > 0) {
                        w = 1
                    }
                })
                idx += w
            }
        })
        return idx === select
    }


    const firstTimeSet = (typeOfBedRooms, typeOfBedRoomsSub) => {
        var uniqueTags = [];
        Object.keys(typeOfBedRooms).map((data, index) => {
            if (uniqueTags.indexOf(data) === -1) {
                uniqueTags.push(data)
            }
        })
        uniqueTags = uniqueTags.sort()
        filterPannerComponentRef.current.reSetTyoeOfBed(uniqueTags)
        uniqueTags = [];
        Object.keys(typeOfBedRoomsSub).map((data, index) => {
            if (uniqueTags.indexOf(data) === -1) {
                uniqueTags.push(data)
            }
        })
        filterPannerComponentRef.current.reSetTyoeOfBedSub(uniqueTags.sort())
    }
    const selectNBComponent = (nb) => {
        setSelectNBVal(nb)
    }

    const selectItem = (item) => {
        ReactKrishViewerRef.current.setState({ selectedItem: item }, () => {
            ReactKrishViewerRef.current.showItem(ReactKrishViewerRef.current, item);
        });
    }


    const onclickHandler = (id) => {
        ReactSession.set("phase", "1")
        ReactSession.set("block", id)
        ReactSession.set("zone", "1")
        ReactSession.set("data", undefined)
        navigate("/blockSelction")
    }
    const toShow = () => {
        svgLoad()
    }
    const remoteActiveOnClick = () => {
    }
    useEffect(() => {
        toShow();
    }, [])


    return (
        <>
            {
                <div className='projectFilterSection' key='project' >
                    <FilterPannerComponent ref={filterPannerComponentRef} updateSvgForBlockSelection={(data) => { updateSvgForBlockSelection(data) }}
                        buildUpArea={buildUpAreaString()}
                        selectNBComponent={(tb) => selectNBComponent(tb)}
                        applyFilter={(filter) => applyFilter(filter)}
                        allBedRooms={allBedRooms}
                        filterPannel={filterPannel}
                        setFilterPannel={setFilterPannel}
                        imageHidden={imageHidden}
                    />

                    <ReactKrishViewer
                        onclickHandler={onclickHandler}
                        ref={ReactKrishViewerRef}
                        loadData={() => loadData()}
                        amount={24}
                        imagePath="assets/images/master_plan"
                        fileName="MasterPlan_Block_Selection_{index}.jpg"
                        spinReverse
                    />

                </div>
            }
        </>
    )
}
export default Projects;